export default __webpack_public_path__ + "2ac5d7bf24234106d3980f694ecb754d.gltf";